<template>
  <div class="tool-page">
    <div class="tool-header">
      <h1>{{ $t('traditional.title') }}</h1>
      <p>{{ $t('traditional.subtitle') }}</p>
    </div>

    <div class="tool-card">
      <div class="actions">
        <button class="btn primary" @click="toTraditional">{{ $t('traditional.toTraditional') }}</button>
        <button class="btn primary" @click="toSimplified">{{ $t('traditional.toSimplified') }}</button>
        <button class="btn" @click="copyResult" :disabled="!output">{{ $t('common.copyResult') }}</button>
        <button class="btn" @click="swapText" :disabled="!output">{{ $t('traditional.swap') }}</button>
        <button class="btn" @click="clearAll">{{ $t('common.clear') }}</button>
      </div>

      <div v-if="message" class="alert" :class="messageType">{{ message }}</div>

      <div class="editor-container">
        <div class="editor-panel">
          <label>{{ $t('traditional.inputLabel') }}</label>
          <textarea
            v-model="input"
            :placeholder="$t('traditional.inputPlaceholder')"
            spellcheck="false"
          ></textarea>
        </div>

        <div class="editor-panel">
          <label>{{ $t('traditional.outputLabel') }}</label>
          <textarea
            v-model="output"
            readonly
            :placeholder="$t('traditional.outputPlaceholder')"
            spellcheck="false"
          ></textarea>
        </div>
      </div>

      <div class="info-section">
        <h3>{{ $t('traditional.aboutTitle') }}</h3>
        <div class="info-content">
          <p>{{ $t('traditional.aboutDesc1') }}</p>
          <p><strong>{{ $t('traditional.aboutUsage') }}</strong></p>
          <p><strong>{{ $t('traditional.aboutValue') }}</strong></p>
        </div>
      </div>
    </div>

    <!-- 工具说明 -->
    <div class="tool-description">
      <h2>{{ $t('traditional.simplificationHistory') }}</h2>
      <p>{{ $t('traditional.simplificationHistoryDesc') }}</p>

      <h2>{{ $t('traditional.conversionChallenges') }}</h2>
      <ul>
        <li v-for="(item, index) in $t('traditional.conversionChallengesItems')" :key="'challenge'+index">{{ item }}</li>
      </ul>

      <h2>{{ $t('traditional.traditionalUseCases') }}</h2>
      <ul>
        <li v-for="(item, index) in $t('traditional.traditionalUseCasesItems')" :key="'usecase'+index">{{ item }}</li>
      </ul>

      <h2>{{ $t('traditional.learningBenefits') }}</h2>
      <ul>
        <li v-for="(item, index) in $t('traditional.learningBenefitsItems')" :key="'benefit'+index">{{ item }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
// 简繁转换映射表（常用字）
const simplifiedToTraditional = {
  '爱': '愛', '碍': '礙', '暗': '闇', '罢': '罷', '备': '備', '贝': '貝', '笔': '筆', '毕': '畢', '边': '邊', '变': '變',
  '标': '標', '表': '錶', '别': '別', '宾': '賓', '卜': '蔔', '补': '補', '才': '纔', '参': '參', '仓': '倉', '层': '層',
  '产': '產', '长': '長', '尝': '嘗', '厂': '廠', '场': '場', '车': '車', '彻': '徹', '陈': '陳', '称': '稱', '惩': '懲',
  '迟': '遲', '冲': '沖', '丑': '醜', '出': '齣', '处': '處', '础': '礎', '触': '觸', '辞': '辭', '聪': '聰', '从': '從',
  '达': '達', '带': '帶', '担': '擔', '当': '當', '党': '黨', '导': '導', '灯': '燈', '邓': '鄧', '敌': '敵', '递': '遞',
  '点': '點', '淀': '澱', '电': '電', '垫': '墊', '调': '調', '叠': '疊', '钉': '釘', '东': '東', '冬': '鼕', '动': '動',
  '斗': '鬥', '独': '獨', '读': '讀', '吨': '噸', '夺': '奪', '堕': '墮', '儿': '兒', '尔': '爾', '发': '發', '范': '範',
  '飞': '飛', '奋': '奮', '坟': '墳', '粪': '糞', '风': '風', '凤': '鳳', '肤': '膚', '妇': '婦', '复': '復', '盖': '蓋',
  '干': '幹', '赶': '趕', '个': '個', '巩': '鞏', '沟': '溝', '构': '構', '购': '購', '谷': '穀', '顾': '顧', '刮': '颳',
  '关': '關', '观': '觀', '惯': '慣', '贯': '貫', '广': '廣', '归': '歸', '龟': '龜', '国': '國', '过': '過', '韩': '韓',
  '汉': '漢', '号': '號', '合': '閤', '轰': '轟', '后': '後', '胡': '鬍', '护': '護', '沪': '滬', '华': '華', '划': '劃',
  '画': '畫', '怀': '懷', '坏': '壞', '欢': '歡', '环': '環', '还': '還', '回': '迴', '会': '會', '汇': '匯', '获': '獲',
  '击': '擊', '机': '機', '积': '積', '鸡': '雞', '极': '極', '际': '際', '继': '繼', '家': '傢', '价': '價', '艰': '艱',
  '坚': '堅', '歼': '殲', '检': '檢', '碱': '鹼', '见': '見', '舰': '艦', '姜': '薑', '将': '將', '奖': '獎', '酱': '醬',
  '讲': '講', '胶': '膠', '阶': '階', '节': '節', '杰': '傑', '洁': '潔', '仅': '僅', '紧': '緊', '进': '進', '惊': '驚',
  '竞': '競', '旧': '舊', '举': '舉', '剧': '劇', '据': '據', '惧': '懼', '卷': '捲', '决': '決', '绝': '絕', '军': '軍',
  '开': '開', '克': '剋', '垦': '墾', '恳': '懇', '夸': '誇', '块': '塊', '宽': '寬', '矿': '礦', '亏': '虧', '困': '睏',
  '扩': '擴', '腊': '臘', '蜡': '蠟', '来': '來', '兰': '蘭', '拦': '攔', '栏': '欄', '烂': '爛', '捞': '撈', '劳': '勞',
  '乐': '樂', '类': '類', '累': '纍', '厘': '釐', '离': '離', '里': '裡', '历': '歷', '丽': '麗', '励': '勵', '隶': '隸',
  '俩': '倆', '联': '聯', '帘': '簾', '怜': '憐', '莲': '蓮', '练': '練', '粮': '糧', '两': '兩', '辆': '輛', '疗': '療',
  '辽': '遼', '了': '瞭', '猎': '獵', '临': '臨', '邻': '鄰', '岭': '嶺', '刘': '劉', '龙': '龍', '楼': '樓', '娄': '婁',
  '卢': '盧', '芦': '蘆', '炉': '爐', '陆': '陸', '录': '錄', '虑': '慮', '滤': '濾', '绿': '綠', '乱': '亂', '罗': '羅',
  '妈': '媽', '马': '馬', '买': '買', '卖': '賣', '麦': '麥', '满': '滿', '猫': '貓', '贸': '貿', '么': '麼', '没': '沒',
  '门': '門', '闷': '悶', '们': '們', '蒙': '矇', '梦': '夢', '弥': '彌', '面': '麵', '灭': '滅', '庙': '廟', '亩': '畝',
  '难': '難', '恼': '惱', '脑': '腦', '闹': '鬧', '拟': '擬', '酿': '釀', '鸟': '鳥', '聂': '聶', '宁': '寧', '农': '農',
  '诺': '諾', '欧': '歐', '盘': '盤', '庞': '龐', '赔': '賠', '喷': '噴', '鹏': '鵬', '骗': '騙', '飘': '飄', '频': '頻',
  '评': '評', '凭': '憑', '苹': '蘋', '朴': '樸', '谱': '譜', '齐': '齊', '骑': '騎', '气': '氣', '启': '啟', '签': '簽',
  '钱': '錢', '枪': '槍', '强': '強', '抢': '搶', '桥': '橋', '窍': '竅', '亲': '親', '寝': '寢', '轻': '輕', '请': '請',
  '庆': '慶', '穷': '窮', '琼': '瓊', '秋': '鞦', '区': '區', '躯': '軀', '趋': '趨', '权': '權', '劝': '勸', '确': '確',
  '让': '讓', '扰': '擾', '热': '熱', '认': '認', '荣': '榮', '软': '軟', '锐': '銳', '润': '潤', '洒': '灑', '伞': '傘',
  '丧': '喪', '扫': '掃', '涩': '澀', '杀': '殺', '晒': '曬', '山': '傘', '伤': '傷', '赏': '賞', '烧': '燒', '绍': '紹',
  '舍': '捨', '摄': '攝', '审': '審', '渗': '滲', '声': '聲', '胜': '勝', '圣': '聖', '师': '師', '狮': '獅', '湿': '濕',
  '时': '時', '实': '實', '识': '識', '适': '適', '势': '勢', '释': '釋', '兽': '獸', '书': '書', '术': '術', '树': '樹',
  '帅': '帥', '双': '雙', '谁': '誰', '顺': '順', '说': '說', '丝': '絲', '松': '鬆', '苏': '蘇', '诉': '訴', '肃': '肅',
  '虽': '雖', '随': '隨', '岁': '歲', '孙': '孫', '损': '損', '缩': '縮', '所': '処', '态': '態', '坛': '壇', '叹': '嘆',
  '汤': '湯', '唐': '堂', '涛': '濤', '讨': '討', '腾': '騰', '体': '體', '条': '條', '铁': '鐵', '听': '聽', '厅': '廳',
  '头': '頭', '图': '圖', '团': '團', '椭': '橢', '拖': '託', '脱': '脫', '驮': '馱', '挖': '窪', '弯': '彎', '湾': '灣',
  '万': '萬', '网': '網', '为': '為', '韦': '韋', '围': '圍', '伪': '偽', '卫': '衛', '温': '溫', '闻': '聞', '问': '問',
  '稳': '穩', '务': '務', '误': '誤', '无': '無', '牺': '犧', '席': '蓆', '系': '係', '戏': '戲', '细': '細', '虾': '蝦',
  '吓': '嚇', '咸': '鹹', '显': '顯', '险': '險', '县': '縣', '宪': '憲', '现': '現', '献': '獻', '乡': '鄉', '详': '詳',
  '响': '響', '项': '項', '向': '嚮', '萧': '蕭', '协': '協', '写': '寫', '泄': '洩', '谢': '謝', '锌': '鋅', '兴': '興',
  '须': '須', '许': '許', '叙': '敘', '续': '續', '选': '選', '学': '學', '勋': '勳', '寻': '尋', '训': '訓', '压': '壓',
  '鸦': '鴉', '哑': '啞', '严': '嚴', '岩': '巖', '颜': '顏', '阳': '陽', '养': '養', '样': '樣', '摇': '搖', '谣': '謠',
  '药': '藥', '页': '頁', '叶': '葉', '业': '業', '医': '醫', '仪': '儀', '艺': '藝', '亿': '億', '忆': '憶', '议': '議',
  '义': '義', '阴': '陰', '银': '銀', '饮': '飲', '隐': '隱', '应': '應', '营': '營', '蝇': '蠅', '拥': '擁', '佣': '傭',
  '踊': '踴', '优': '優', '忧': '憂', '邮': '郵', '犹': '猶', '游': '遊', '渔': '漁', '与': '與', '屿': '嶼', '语': '語',
  '吁': '籲', '誉': '譽', '预': '預', '郁': '鬱', '狱': '獄', '御': '禦', '员': '員', '园': '園', '远': '遠', '愿': '願',
  '约': '約', '跃': '躍', '运': '運', '韵': '韻', '酝': '醞', '杂': '雜', '灾': '災', '赃': '贓', '暂': '暫', '赞': '贊',
  '脏': '髒', '凿': '鑿', '责': '責', '择': '擇', '则': '則', '泽': '澤', '贼': '賊', '赠': '贈', '斋': '齋', '战': '戰',
  '张': '張', '涨': '漲', '账': '賬', '赵': '趙', '折': '摺', '这': '這', '针': '針', '侦': '偵', '镇': '鎮', '争': '爭',
  '证': '證', '郑': '鄭', '织': '織', '执': '執', '职': '職', '纸': '紙', '制': '製', '质': '質', '滞': '滯', '钟': '鐘',
  '种': '種', '众': '眾', '周': '週', '皱': '皺', '昼': '晝', '朱': '硃', '烛': '燭', '属': '屬', '嘱': '囑', '专': '專',
  '转': '轉', '庄': '莊', '装': '裝', '状': '狀', '坠': '墜', '准': '準', '浊': '濁', '咨': '諮', '资': '資', '总': '總',
  '纵': '縱', '钻': '鑽', '组': '組', '最': '最'
}

// 生成反向映射
const traditionalToSimplified = {}
for (const [s, t] of Object.entries(simplifiedToTraditional)) {
  traditionalToSimplified[t] = s
}

export default {
  name: 'TraditionalConverter',
  data() {
    return {
      input: '',
      output: '',
      message: '',
      messageType: 'success'
    }
  },
  methods: {
    toTraditional() {
      if (!this.input.trim()) {
        this.showMessage(this.$t('traditional.emptyError'), 'error')
        return
      }
      
      let result = ''
      for (const char of this.input) {
        result += simplifiedToTraditional[char] || char
      }
      this.output = result
      this.showMessage(this.$t('traditional.toTraditionalSuccess'), 'success')
    },

    toSimplified() {
      if (!this.input.trim()) {
        this.showMessage(this.$t('traditional.emptyError'), 'error')
        return
      }
      
      let result = ''
      for (const char of this.input) {
        result += traditionalToSimplified[char] || char
      }
      this.output = result
      this.showMessage(this.$t('traditional.toSimplifiedSuccess'), 'success')
    },

    async copyResult() {
      if (!this.output) return
      
      try {
        await navigator.clipboard.writeText(this.output)
        this.showMessage(this.$t('common.copied'), 'success')
      } catch (e) {
        // 降级方案
        const textarea = document.createElement('textarea')
        textarea.value = this.output
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.showMessage(this.$t('common.copied'), 'success')
      }
    },

    swapText() {
      const temp = this.input
      this.input = this.output
      this.output = temp
    },

    clearAll() {
      this.input = ''
      this.output = ''
      this.message = ''
    },

    showMessage(msg, type) {
      this.message = msg
      this.messageType = type
      setTimeout(() => {
        this.message = ''
      }, 3000)
    }
  }
}
</script>

<style scoped>
.tool-page {
  max-width: 900px;
  margin: 0 auto;
}

.tool-header {
  text-align: center;
  margin-bottom: 32px;
}

.tool-header h1 {
  font-size: 32px;
  margin-bottom: 12px;
  color: var(--text-primary);
}

.tool-header p {
  color: var(--text-secondary);
  font-size: 16px;
}

.tool-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 24px;
  box-shadow: var(--shadow-md);
  transition: background 0.3s, border-color 0.3s;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
}

.btn {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.btn:hover:not(:disabled) {
  background: var(--bg-hover);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn.primary {
  background: var(--accent-color);
  color: white;
  border-color: var(--accent-color);
}

.btn.primary:hover {
  background: var(--accent-hover);
}

.alert {
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 14px;
}

.alert.success {
  background: rgba(34, 197, 94, 0.1);
  color: var(--success-color);
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.alert.error {
  background: rgba(239, 68, 68, 0.1);
  color: var(--error-color);
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.editor-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 24px;
}

@media (max-width: 768px) {
  .editor-container {
    grid-template-columns: 1fr;
  }
}

.editor-panel {
  display: flex;
  flex-direction: column;
}

.editor-panel label {
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.editor-panel textarea {
  flex: 1;
  min-height: 200px;
  background: var(--bg-input);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 16px;
  color: var(--text-primary);
  font-size: 16px;
  line-height: 1.8;
  resize: vertical;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  transition: background 0.3s, border-color 0.3s, color 0.3s;
}

.editor-panel textarea:focus {
  outline: none;
  border-color: var(--accent-color);
}

.editor-panel textarea::placeholder {
  color: var(--text-muted);
}

.editor-panel textarea[readonly] {
  background: var(--bg-tertiary);
}

.info-section {
  background: var(--bg-tertiary);
  border-radius: 12px;
  padding: 20px;
}

.info-section h3 {
  font-size: 16px;
  color: var(--text-primary);
  margin-bottom: 12px;
}

.info-content p {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.8;
  margin-bottom: 8px;
}

.info-content p:last-child {
  margin-bottom: 0;
}

.tool-description {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 32px;
  margin-top: 32px;
  box-shadow: var(--shadow-md);
}

.tool-description h2 {
  font-size: 20px;
  color: var(--text-primary);
  margin: 28px 0 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-color);
}

.tool-description h2:first-child {
  margin-top: 0;
}

.tool-description p {
  font-size: 15px;
  color: var(--text-secondary);
  line-height: 1.8;
  margin-bottom: 12px;
}

.tool-description ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.tool-description li {
  font-size: 15px;
  color: var(--text-secondary);
  line-height: 1.8;
  padding-left: 20px;
  position: relative;
  margin-bottom: 8px;
}

.tool-description li::before {
  content: '•';
  color: var(--accent-color);
  position: absolute;
  left: 0;
}
</style>
